// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_loginContainer__32cQc {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 60px);
  padding: var(--sp-10) var(--sp-5);
  background-color: var(--color-bg);
  position: relative;
  overflow: hidden;
}

.Login_loginBox__JhG46 {
  position: relative;
  background-color: var(--color-bg);
  padding: var(--sp-10) var(--sp-8);
  border-radius: var(--radius-2xl);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-xl), 0 24px 60px -20px rgba(14, 165, 233, 0.22);
  width: 100%;
  max-width: 440px;
  text-align: center;
  z-index: 1;
}
.Login_loginBox__JhG46::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0EA5E9, #8B5CF6, #F472B6);
  border-radius: var(--radius-2xl) var(--radius-2xl) 0 0;
}

.Login_loginTitle__txhRz {
  font-size: 32px;
  font-weight: var(--fw-bold);
  letter-spacing: -0.02em;
  margin: 0 0 var(--sp-6);
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.Login_inputContainer__gVd1u,
.Login_passwordInputContainer__CyS2\\+ {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: var(--sp-3) 0;
}

.Login_passwordInputContainer__CyS2\\+ {
  flex-direction: row;
  align-items: center;
}

.Login_noeye_inputField__\\+OpGd,
.Login_inputField__G7nnJ {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  box-sizing: border-box;
  border: 1.5px solid var(--color-field-border);
  border-radius: var(--radius-md);
  background-color: var(--color-field-bg);
  font-size: 15px;
  font-family: var(--font-sans);
  color: var(--color-text);
  transition: border-color var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard), background var(--duration-base) var(--easing-standard);
}
.Login_noeye_inputField__\\+OpGd::placeholder,
.Login_inputField__G7nnJ::placeholder {
  color: var(--color-field-placeholder);
}
.Login_noeye_inputField__\\+OpGd:hover,
.Login_inputField__G7nnJ:hover {
  border-color: var(--color-field-border-hover);
}
.Login_noeye_inputField__\\+OpGd:focus,
.Login_inputField__G7nnJ:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 4px var(--color-primary-ring);
}

.Login_passwordInputContainer__CyS2\\+ .Login_inputField__G7nnJ {
  padding-right: 44px;
}

.Login_togglePassword__s1tb9 {
  position: absolute;
  right: 16px;
  cursor: pointer;
  width: 22px;
  height: 16px;
  opacity: 0.55;
  transition: opacity var(--duration-base) var(--easing-standard);
}
.Login_togglePassword__s1tb9:hover {
  opacity: 1;
}
[data-theme=dark] .Login_togglePassword__s1tb9 {
  filter: invert(1) brightness(1.2);
}

.Login_loginButton__Ipmse {
  width: 100%;
  height: 48px;
  margin-top: var(--sp-5);
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: var(--fw-semibold);
  letter-spacing: 0.05em;
  cursor: pointer;
  box-shadow: 0 8px 20px -6px rgba(14, 165, 233, 0.5);
  transition: transform var(--duration-base) var(--easing-standard), box-shadow var(--duration-base) var(--easing-standard), opacity var(--duration-base) var(--easing-standard);
  font-family: var(--font-sans);
}
.Login_loginButton__Ipmse:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -8px rgba(14, 165, 233, 0.7);
}
.Login_loginButton__Ipmse:active {
  transform: translateY(0);
}
.Login_loginButton__Ipmse:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.Login_matchMessage__hgX2s {
  color: var(--color-success);
  font-size: 13px;
  margin: 6px 0 0;
  text-align: left;
  padding-left: 4px;
}

.Login_errorMessage__TCZLP,
.Login_loginErrorMessage__49m\\+Y {
  color: var(--color-danger);
  font-size: 13px;
  margin: 6px 0 0;
  text-align: left;
  padding-left: 4px;
}

.Login_signUpText__Bv\\+pP,
.Login_findText__0rJm9,
.Login_loginText__voKDh {
  margin-top: var(--sp-4);
  font-size: 14px;
  color: var(--color-text-muted);
}

.Login_findText__0rJm9 {
  text-align: right;
  margin-top: var(--sp-2);
}

.Login_signUpLink__OfLQd,
.Login_findLink__SQfgy,
.Login_loginLink__uB7lh {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: var(--fw-semibold);
  transition: color var(--duration-base) var(--easing-standard);
}
.Login_signUpLink__OfLQd:hover,
.Login_findLink__SQfgy:hover,
.Login_loginLink__uB7lh:hover {
  color: var(--color-primary-hover);
  text-decoration: underline;
}

.Login_successMessageLarge__0MKle {
  font-size: 15px;
  text-align: center;
  margin: var(--sp-5) 0;
  padding: var(--sp-5);
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%);
  border: 1px solid rgba(14, 165, 233, 0.25);
  border-radius: var(--radius-lg);
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  align-items: center;
}

.Login_messagePrefix__4DFEE {
  font-size: 13px;
  color: var(--color-text-muted);
  font-weight: var(--fw-medium);
}

.Login_username__83H7b {
  font-size: 22px;
  font-weight: var(--fw-bold);
  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;EAIA,iCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EAIA,qCAAA;EACA,wEACE;EAEF,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAVF;AAYE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,6DAAA;EACA,sDAAA;AAVJ;;AAcA;EACE,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,6DAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;AAXF;;AAeA;;EAEE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,mBAAA;AAZF;;AAeA;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,6CAAA;EACA,+BAAA;EAEA,uCAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,oLAAA;AAbF;AAiBE;;EACE,qCAAA;AAdJ;AAiBE;;EACE,6CAAA;AAdJ;AAiBE;;EACE,aAAA;EACA,kCAAA;EACA,+CAAA;AAdJ;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+DAAA;AAfF;AAiBE;EAAU,UAAA;AAdZ;AAmBE;EACE,iCAAA;AAjBJ;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,6DAAA;EACA,cAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,mDAAA;EACA,8KAAA;EAGA,6BAAA;AArBF;AAuBE;EACE,2BAAA;EACA,oDAAA;AArBJ;AAwBE;EACE,wBAAA;AAtBJ;AAyBE;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAvBJ;;AA4BA;EACE,2BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAzBF;;AA4BA;;EAEE,0BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAzBF;;AA6BA;;;EAGE,uBAAA;EACA,eAAA;EACA,8BAAA;AA1BF;;AA6BA;EACE,iBAAA;EACA,uBAAA;AA1BF;;AA6BA;;;EAGE,2BAAA;EACA,qBAAA;EACA,+BAAA;EACA,6DAAA;AA1BF;AA4BE;;;EACE,iCAAA;EACA,0BAAA;AAxBJ;;AA6BA;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,+FAAA;EACA,0CAAA;EACA,+BAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,8BAAA;EACA,6BAAA;AA1BF;;AA6BA;EACE,eAAA;EACA,2BAAA;EACA,6DAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,qBAAA;AA1BF","sourcesContent":["// Login / FindUsername / FindPassword shared stylesheet.\n// Class names preserved so all three pages adopt the new tone without JSX changes.\n\n.loginContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - 60px);\n  padding: var(--sp-10) var(--sp-5);\n  // Tokenized solid surface — identical to the NaviBar's --color-bg so there's\n  // no seam in either light or dark mode. No gradients/blooms: even low-alpha\n  // ellipses leave a visible edge against the solid navbar above.\n  background-color: var(--color-bg);\n  position: relative;\n  overflow: hidden;\n}\n\n.loginBox {\n  position: relative;\n  background-color: var(--color-bg);\n  padding: var(--sp-10) var(--sp-8);\n  border-radius: var(--radius-2xl);\n  // Thin border + neutral elevation + a soft sky-tinted glow under the card so it\n  // still feels lifted on the now fully-white backdrop. Brand color now lives on\n  // the card, not the page background.\n  border: 1px solid var(--color-border);\n  box-shadow:\n    var(--shadow-xl),\n    0 24px 60px -20px rgba(14, 165, 233, 0.22);\n  width: 100%;\n  max-width: 440px;\n  text-align: center;\n  z-index: 1;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #0EA5E9, #8B5CF6, #F472B6);\n    border-radius: var(--radius-2xl) var(--radius-2xl) 0 0;\n  }\n}\n\n.loginTitle {\n  font-size: 32px;\n  font-weight: var(--fw-bold);\n  letter-spacing: -0.02em;\n  margin: 0 0 var(--sp-6);\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n\n// ---------- Inputs ----------\n.inputContainer,\n.passwordInputContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: var(--sp-3) 0;\n}\n\n.passwordInputContainer {\n  flex-direction: row;\n  align-items: center;\n}\n\n.noeye_inputField,\n.inputField {\n  width: 100%;\n  height: 48px;\n  padding: 0 16px;\n  box-sizing: border-box;\n  border: 1.5px solid var(--color-field-border);\n  border-radius: var(--radius-md);\n  // --color-bg 를 쓰면 다크모드에서 페이지 배경과 같은 색이라 입력칸이 사라집니다.\n  background-color: var(--color-field-bg);\n  font-size: 15px;\n  font-family: var(--font-sans);\n  color: var(--color-text);\n  transition: border-color var(--duration-base) var(--easing-standard),\n              box-shadow var(--duration-base) var(--easing-standard),\n              background var(--duration-base) var(--easing-standard);\n\n  &::placeholder {\n    color: var(--color-field-placeholder);\n  }\n\n  &:hover {\n    border-color: var(--color-field-border-hover);\n  }\n\n  &:focus {\n    outline: none;\n    border-color: var(--color-primary);\n    box-shadow: 0 0 0 4px var(--color-primary-ring);\n  }\n}\n\n.passwordInputContainer .inputField {\n  padding-right: 44px;\n}\n\n.togglePassword {\n  position: absolute;\n  right: 16px;\n  cursor: pointer;\n  width: 22px;\n  height: 16px;\n  opacity: 0.55;\n  transition: opacity var(--duration-base) var(--easing-standard);\n\n  &:hover { opacity: 1; }\n\n  // PNG 아이콘이라 CSS color로 톤 변경이 안 됨 — 다크모드에서 어두운 눈 아이콘이\n  // 어두운 배경(slate-900)에 묻혀버리므로 filter로 색을 반전시켜 밝게 보이게.\n  // Login/Signup/FindUsername 4곳 모두 같은 클래스라 한 곳만 고쳐도 전부 적용됨.\n  [data-theme=\"dark\"] & {\n    filter: invert(1) brightness(1.2);\n  }\n}\n\n// ---------- Buttons ----------\n.loginButton {\n  width: 100%;\n  height: 48px;\n  margin-top: var(--sp-5);\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  box-shadow: 0 8px 20px -6px rgba(14, 165, 233, 0.5);\n  transition: transform var(--duration-base) var(--easing-standard),\n              box-shadow var(--duration-base) var(--easing-standard),\n              opacity var(--duration-base) var(--easing-standard);\n  font-family: var(--font-sans);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 28px -8px rgba(14, 165, 233, 0.7);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n// ---------- Messages ----------\n.matchMessage {\n  color: var(--color-success);\n  font-size: 13px;\n  margin: 6px 0 0;\n  text-align: left;\n  padding-left: 4px;\n}\n\n.errorMessage,\n.loginErrorMessage {\n  color: var(--color-danger);\n  font-size: 13px;\n  margin: 6px 0 0;\n  text-align: left;\n  padding-left: 4px;\n}\n\n// ---------- Footer links ----------\n.signUpText,\n.findText,\n.loginText {\n  margin-top: var(--sp-4);\n  font-size: 14px;\n  color: var(--color-text-muted);\n}\n\n.findText {\n  text-align: right;\n  margin-top: var(--sp-2);\n}\n\n.signUpLink,\n.findLink,\n.loginLink {\n  color: var(--color-primary);\n  text-decoration: none;\n  font-weight: var(--fw-semibold);\n  transition: color var(--duration-base) var(--easing-standard);\n\n  &:hover {\n    color: var(--color-primary-hover);\n    text-decoration: underline;\n  }\n}\n\n// ---------- Success result block (FindUsername / FindPassword) ----------\n.successMessageLarge {\n  font-size: 15px;\n  text-align: center;\n  margin: var(--sp-5) 0;\n  padding: var(--sp-5);\n  background: linear-gradient(135deg, rgba(14, 165, 233, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%);\n  border: 1px solid rgba(14, 165, 233, 0.25);\n  border-radius: var(--radius-lg);\n  color: var(--color-text);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-2);\n  align-items: center;\n}\n\n.messagePrefix {\n  font-size: 13px;\n  color: var(--color-text-muted);\n  font-weight: var(--fw-medium);\n}\n\n.username {\n  font-size: 22px;\n  font-weight: var(--fw-bold);\n  background: linear-gradient(135deg, #0EA5E9 0%, #8B5CF6 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `Login_loginContainer__32cQc`,
	"loginBox": `Login_loginBox__JhG46`,
	"loginTitle": `Login_loginTitle__txhRz`,
	"inputContainer": `Login_inputContainer__gVd1u`,
	"passwordInputContainer": `Login_passwordInputContainer__CyS2+`,
	"noeye_inputField": `Login_noeye_inputField__+OpGd`,
	"inputField": `Login_inputField__G7nnJ`,
	"togglePassword": `Login_togglePassword__s1tb9`,
	"loginButton": `Login_loginButton__Ipmse`,
	"matchMessage": `Login_matchMessage__hgX2s`,
	"errorMessage": `Login_errorMessage__TCZLP`,
	"loginErrorMessage": `Login_loginErrorMessage__49m+Y`,
	"signUpText": `Login_signUpText__Bv+pP`,
	"findText": `Login_findText__0rJm9`,
	"loginText": `Login_loginText__voKDh`,
	"signUpLink": `Login_signUpLink__OfLQd`,
	"findLink": `Login_findLink__SQfgy`,
	"loginLink": `Login_loginLink__uB7lh`,
	"successMessageLarge": `Login_successMessageLarge__0MKle`,
	"messagePrefix": `Login_messagePrefix__4DFEE`,
	"username": `Login_username__83H7b`
};
export default ___CSS_LOADER_EXPORT___;
